<template>
  <div class="lg:px-20 md:px-12 px-5 lg:py-8 md:py-8 py-6">
    <div class="text-center">
      <p class="fsize30 sm-fsize22 font-semibold clr-black pb-6">
        Our Trusted Corporate Partners
      </p>
    </div>
    <swiper :options="swiperOption" class="mySwiper">
      <swiper-slide
        class="p-4 bg-white rounded-xl"
        :key="index"
        v-for="(item, index) in ffc_partner.result"
      >
        <div class="">
          <img
            :src="`${$imageURL}/${item.image}`"
            class="comp-img w-auto h-auto"
            alt="img"
            @click="openURL(item.link)"
          />
        </div>
      </swiper-slide>
      <!-- <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div> -->
    </swiper>
  </div>
</template>
<script>
import "swiper/dist/css/swiper.min.css";
import { mapState } from "vuex";
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  data() {
    return {
      swiperOption: {
        slidesPerView: 6,
        spaceBetween: 30,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
        },
        breakpoints: {
          1600: {
            slidesPerView: 6,
            spaceBetween: 30,
          },
          1300: {
            slidesPerView: 6,
            spaceBetween: 30,
          },
          900: {
            slidesPerView: 6,
            spaceBetween: 20,
          },
          820: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 15,
          },
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        observer: true,
        observeParents: true,
      },

      openAddBannerSidebar: false,
    };
  },
  components: {
    swiper,
    swiperSlide,
  },
  methods: {
    openURL(VALUE) {
      window.open(VALUE, "_blank");
    },
  },

  computed: {
    ...mapState("ffc", { ffc_partner: "ffc_partner" }),
  },
};
</script>
<style>
.comp-img {
  width: 100%;
  height: 100px;
  aspect-ratio: 2 / 1;
  object-fit: contain;
}
@media (max-width: 820px) {
  .comp-img {
    width: 100% !important;
    height: 100px !important;
    aspect-ratio: 1 / 1 !important;
    object-fit: contain;
  }
}
</style>
